var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57 2.72c.62-1.08 2.18-1.08 2.8 0l6.6 11.43c.62 1.08-.16 2.43-1.4 2.43H3.37c-1.24 0-2.02-1.35-1.4-2.43l6.6-11.43z",
    stroke: "#E0A408",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5v3.5",
    stroke: "#E0A408",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13.4,
    r: 0.9,
    fill: "#E0A408"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningGold);
export default __webpack_public_path__ + "static/media/icon-warning-gold.654ce00f32d05394d5264a7773200784.svg";
export { ForwardRef as ReactComponent };